<h2 mat-dialog-title>Importar Extrato Bancário</h2>

<mat-dialog-content fxLayout="column">
    <div style="padding-bottom: 0.5rem">
        <!-- Hidden File Input -->
        <arquivo-extrato-file-input
            #fileInput
            (selecionado)="onArquivoSelecionado($event)">
        </arquivo-extrato-file-input>

        <!-- Upload Area -->
        <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 20px; margin-bottom: 20px;">
            <div (click)="!arquivoSelecionado && triggerFileInput()"
                 (dragleave)="onDragLeave($event)"
                 (dragover)="onDragOver($event)"
                 (drop)="onDrop($event)"
                 [class.drag-over]="isDragOver"
                 [class.has-file]="arquivoSelecionado"
                 class="upload-area">

                <!-- Upload Icon -->
                <div class="upload-icon">
                    <mat-icon *ngIf="!arquivoSelecionado">cloud_upload</mat-icon>
                    <mat-icon *ngIf="arquivoSelecionado">description</mat-icon>
                </div>

                <!-- Content based on state -->
                <div *ngIf="!arquivoSelecionado" class="upload-content">
                    <h3 class="upload-title">Selecionar Arquivo</h3>
                    <p class="upload-instructions">
                        Arraste e solte seu arquivo aqui ou clique para selecionar
                    </p>
                    <p class="accepted-formats">Formatos aceitos: OFX, TXT</p>
                </div>

                <div *ngIf="arquivoSelecionado" class="file-content">
                    <h3 class="file-name">{{ getNomeArquivo() }}</h3>
                    <p class="file-details">{{ getTamanhoArquivo() }} • Arquivo {{ getFormatoArquivo() }}</p>
                    <div class="file-status">
                        <mat-icon class="status-icon">check_circle</mat-icon>
                        <span class="status-text">Pronto para importação</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div *ngIf="arquivoSelecionado" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" style="margin-top: 16px;">
            <button (click)="triggerFileInput($event)"
                    color="primary"
                    mat-stroked-button>
                <mat-icon>swap_horiz</mat-icon>
                Trocar Arquivo
            </button>

            <button (click)="limparSelecao()"
                    mat-icon-button
                    matTooltip="Remover arquivo">
                <mat-icon color="warn">close</mat-icon>
            </button>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    <button (click)="voltar()" mat-button>Cancelar</button>
    <button (click)="confirmar()"
            [disabled]="!arquivoSelecionado"
            color="primary"
            mat-raised-button>
        <mat-icon>cloud_upload</mat-icon>
        Importar Arquivo
    </button>
</mat-dialog-actions>
